import { render } from "./SignUpMethodChooser.vue?vue&type=template&id=782cf130&scoped=true"
import script from "./SignUpMethodChooser.vue?vue&type=script&lang=js"
export * from "./SignUpMethodChooser.vue?vue&type=script&lang=js"

import "./SignUpMethodChooser.vue?vue&type=style&index=0&id=782cf130&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782cf130"]])

export default __exports__